import { render, staticRenderFns } from "./ComparazioneVersioni.vue?vue&type=template&id=d747be10&"
import script from "./ComparazioneVersioni.vue?vue&type=script&lang=js&"
export * from "./ComparazioneVersioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports